import { render, staticRenderFns } from "./SelectComponent.vue?vue&type=template&id=b4714c6c&scoped=true&"
import script from "./SelectComponent.vue?vue&type=script&lang=js&"
export * from "./SelectComponent.vue?vue&type=script&lang=js&"
import style0 from "./SelectComponent.vue?vue&type=style&index=0&id=b4714c6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4714c6c",
  null
  
)

export default component.exports